
import Vue, { PropType } from 'vue';
import Close16 from '@carbon/icons-vue/es/close/16';
import Checkmark16 from '@carbon/icons-vue/es/checkmark/16';
import { CvTile } from '@carbon/vue';
import { MethodResult, MethodResultData } from '../../typings/index';

const LOGO_ONLY = 'Logo only';
const PERSONALISE = 'Personalise';
const PERSONALISE_NEW = 'PersonaliseNew';
const FULL_DESIGN = 'Full design';
const FULL_DESIGN_ARTWORKS = 'Full design artworks';
const SELECT_PERSONALISE_METHOD = 'Select personalise method';

export default Vue.extend({
  components: { Checkmark16, Close16, CvTile },

  model: {
    prop: 'methodResults',
  },

  props: {
    methodTitle: {
      type: String,
      required: true,
    },
    methodName: {
      type: String,
      required: true,
    },
    methodItems: {
      type: Array as PropType<string[]>,
      required: true,
    },
    methodItemAvailabilities: {
      type: Array as PropType<boolean[]>,
      required: true,
    },
    methodResults: {
      type: Object as PropType<MethodResult>,
      required: true,
    },
    isMethodPreselected: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      isSelected: false,
      currentMethodSelected: {
        methodName: '',
        isSelected: false,
      } as MethodResultData,
    };
  },

  created() {
    if (this.methodName === 'personalise' && this.isMethodPreselected) {
      this.currentMethodSelected = this.methodResults['personalise'];
      this.currentMethodSelected.isSelected = true;

      this.methodResults['logoOnly'].isSelected = false;
      this.methodResults['personaliseNew'].isSelected = false;
      this.methodResults['fullDesign'].isSelected = false;
      this.methodResults['fullDesignArtworks'].isSelected = false;

      this.$emit('update:selected-method', PERSONALISE);

      return;
    }
    if (this.methodName === 'personaliseNew' && this.isMethodPreselected) {
      this.currentMethodSelected = this.methodResults['personaliseNew'];
      this.currentMethodSelected.isSelected = true;

      this.methodResults['logoOnly'].isSelected = false;
      this.methodResults['fullDesign'].isSelected = false;
      this.methodResults['fullDesignArtworks'].isSelected = false;

      this.$emit('update:selected-method', PERSONALISE_NEW);

      return;
    }
  },

  methods: {
    onChange(event: boolean) {
      if (event) {
        if (this.methodName === 'logoOnly') {
          this.currentMethodSelected = this.methodResults['logoOnly'];
          this.currentMethodSelected.isSelected = event;

          this.methodResults['personalise'].isSelected = false;
          this.methodResults['personaliseNew'].isSelected = false;
          this.methodResults['fullDesign'].isSelected = false;
          this.methodResults['fullDesignArtworks'].isSelected = false;

          this.$emit('update:selected-method', LOGO_ONLY);

          return;
        }

        if (this.methodName === 'personalise') {
          this.currentMethodSelected = this.methodResults['personalise'];
          this.currentMethodSelected.isSelected = event;

          this.methodResults['personaliseNew'].isSelected = false;
          this.methodResults['logoOnly'].isSelected = false;
          this.methodResults['fullDesign'].isSelected = false;
          this.methodResults['fullDesignArtworks'].isSelected = false;

          this.$emit('update:selected-method', PERSONALISE);

          return;
        }

        if (this.methodName === 'personaliseNew') {
          this.currentMethodSelected = this.methodResults['personaliseNew'];
          this.currentMethodSelected.isSelected = event;

          this.methodResults['personalise'].isSelected = false;
          this.methodResults['logoOnly'].isSelected = false;
          this.methodResults['fullDesign'].isSelected = false;
          this.methodResults['fullDesignArtworks'].isSelected = false;

          this.$emit('update:selected-method', PERSONALISE_NEW);

          return;
        }

        if (this.methodName === 'fullDesign') {
          this.currentMethodSelected = this.methodResults['fullDesign'];
          this.currentMethodSelected.isSelected = event;

          this.methodResults['personaliseNew'].isSelected = false;
          this.methodResults['personalise'].isSelected = false;
          this.methodResults['logoOnly'].isSelected = false;
          this.methodResults['fullDesignArtworks'].isSelected = false;

          this.$emit('update:selected-method', FULL_DESIGN);

          return;
        }

        if (this.methodName === 'fullDesignArtworks') {
          this.currentMethodSelected = this.methodResults['fullDesignArtworks'];
          this.currentMethodSelected.isSelected = event;

          this.methodResults['personalise'].isSelected = false;
          this.methodResults['logoOnly'].isSelected = false;
          this.methodResults['fullDesign'].isSelected = false;

          this.$emit('update:selected-method', FULL_DESIGN_ARTWORKS);

          return;
        }

        return;
      }

      this.methodResults['logoOnly'].isSelected = false;
      this.methodResults['personalise'].isSelected = false;
      this.methodResults['fullDesign'].isSelected = false;
      this.methodResults['fullDesignArtworks'].isSelected = false;

      this.$emit('update:selected-method', SELECT_PERSONALISE_METHOD);
    },
  },
});
